module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PsYm3k/tc-custom/9781783468874.jpg?1718183631614",
      "alt": "This image is the cover for the book Build Up to the Beginning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Build Up to the Beginning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is the first volume of a most impressive tribute and accurate four part work that uniquely presents a complete account of the air operations throughout Market-Garden in September 1944 when British, US and Polish airborne troops made a gallant attempt to seize and hold bridges across the Lower Rhine in Holland as a springboard for crossing into Germany. Market, the aerial side of the proceedings, was at the time the largest airborne operation in history. In this unprecedented and insightful account, the exploits of the First Allied Airborne Army are relayed in full detail; supplemented with historical notes regarding the ground operations, this is sure to offer an unparalleled account of the events as they unfolded in the skies above Holland.If successful, the war could be over by Christmas. What could go wrong? That it did and on such a massive scale is the underlying theme throughout this series. The action was at times very confused, so a narrative of events contained in sixteen timelines at intervals throughout this series cuts through the fog of battle to explain the situation from its over-optimistic beginning to the tragic conclusion.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Martin W. Bowman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Martin Bowman is one of Britain’s foremost aviation historians and has written many books and articles.   He lives in Norwich.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0